import { SortDirection } from '../../../../aumico-lib-cpmm-fe/src/lib/enums/sort-direction.enum';
import { ProjectSortingProperties } from '../enums/project-sorting-properties.enum';

export interface ProjectsFilter {
    companyIds?: string[];

    /** REV-22155 — tags of the company; `aumico-be` resolves them via aumico-ms-companies. */
    tagIds?: string[];

    assignee?: string[] | null;

    projectStatus?: string[] | null;

    reportTypeIds?: string[] | null;

    companyName?: string;

    startDate?: string;

    endDate?: string;

    years?: number[];

    offset?: number;

    limit?: number;

    sortBy?: ProjectSortingProperties;

    sortOrder?: SortDirection;
}
